module.exports = __webpack_public_path__ + "static/media/ReportActive.9cc79265.png";